import React from 'react';
import Icon from '@ant-design/icons/lib/components/Icon';
import { Button, Modal } from 'antd';
import { ReactComponent as CrossSVG } from '../../../assets/sightx-icons/svg/x-close.svg';
import { ReactComponent as CautionSVG } from '../../../assets/sightx-icons/svg/sx-exclamation-triangle.svg';
import { ReactComponent as TrashSVG } from '../../../assets/sightx-icons/svg/icon-delete.svg';
import { HighlightedText } from '../highlightText';

import styles from './index.module.scss';

interface DeleteModalProps {
  title: string;
  description: string;
  onProceed: () => void;
  onCancel: () => void;
}
/**
 * @deprecated
 * @description Reason: Cancel and close should be separate/different actions
 *
 */
export const DeleteModalOld: React.FC<DeleteModalProps> = (props) => {
  return (
    <Modal
      visible
      onCancel={props.onCancel}
      className={styles.modal}
      footer={null}
      width={400}
      closeIcon={<Icon className={styles.closeIcon} component={CrossSVG} />}
    >
      <div className={styles.icon}>
        <Icon className={styles.dangerIcon} component={CautionSVG} />
      </div>
      <div className={styles.title}>{props.title}</div>
      <div className={styles.description}>{props.description}</div>
      <div className={styles.footer}>
        <Button type="default" className={styles.oldCancelButton} onClick={props.onCancel}>Cancel</Button>
        <Button type="primary" className={styles.proceedButton} onClick={props.onProceed}>Proceed</Button>
      </div>
    </Modal>
  );
};

const renderTextOrComponent = (textOrElement: string | React.ReactElement): React.ReactElement => {
  if (typeof textOrElement === 'string') {
    return (
      <div className={styles.descriptionContainer}>
        <div className={styles.description}>
          {textOrElement}
        </div>
      </div>
    );
  }

  return (
    <div className={styles.descriptionContainer}>
      { textOrElement }
    </div>
  );
};

interface Props {
  title: string;
  description: string | React.ReactElement;
  highlightOnDescriptionText?: string;
  subdescription?: string | React.ReactElement;
  onAccept: () => void;
  onCancel: () => void;
  onClose: () => void;
  acceptText?: string;
  cancelText?: string;
  closeSvgIcon?: typeof React.Component;
  actionSvgIcon?: typeof React.Component;
}
export const DeleteModal: React.FC<Props> = (props) => {
  let descriptionToRender: string | React.ReactElement = props.description;
  if(typeof props.description === 'string' && !!props.highlightOnDescriptionText) {
    descriptionToRender = <HighlightedText text={props.description} highlight={props.highlightOnDescriptionText || ''} />;
  }

  return (
    <Modal
      visible
      onCancel={props.onClose}
      className={styles.modal}
      footer={null}
      width={400}
      closeIcon={<Icon className={styles.closeIcon} component={props.closeSvgIcon || CrossSVG} />}
    >
      <div className={styles.icon}>
        <Icon className={styles.dangerIcon} component={props.actionSvgIcon || TrashSVG} />
      </div>
      <div className={styles.title}>{props.title}</div>
      { renderTextOrComponent(descriptionToRender) }
      { props.subdescription ? renderTextOrComponent(props.subdescription) : null }
      <div className={styles.footer}>
        <Button type="default" className={styles.cancelButton} onClick={props.onCancel}>{props.cancelText || 'Cancel'}</Button>
        <Button type="primary" className={styles.proceedButton} onClick={props.onAccept}>{props.acceptText || 'Delete'}</Button>
      </div>
    </Modal>
  );
};
